import React, { useContext } from 'react';
import classNames from 'classnames';
import AppContext from '../context/Context';
import NavbarTop from '../components/navbar/NavbarTop';
import NavbarVertical from '../components/navbar/NavbarVertical';
import Footer from '../components/footer/Footer';
import SidePanel from '../components/common/SidePanel';
import DashboardRoutes from './DashboardRoutes';

const DashboardLayout = () => {
  const { isFluid, isSidebarCollapsed, navbarPosition } = useContext(AppContext);
  const showVerticalNavbar = navbarPosition !== 'top';

  return (
    <div
      className={classNames(isFluid ? 'container-fluid' : 'container', 'psi-layout-shell', {
        'psi-layout-shell--collapsed': showVerticalNavbar && isSidebarCollapsed,
        'psi-layout-shell--top': navbarPosition === 'top',
        'psi-layout-shell--combo': navbarPosition === 'combo'
      })}
    >
      {showVerticalNavbar && <NavbarVertical />}
      <SidePanel />
      <div className="content">
        <NavbarTop />
        <DashboardRoutes />
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;
